export enum PdfCreditType {
  Credit = 0,
}
